import { ROUTES, ROLES } from '@/constants';
import { ADMIN_PORTAL_PERMISSIONS } from '@/constants/permissions';
import { getEffectivePermissions, hasAllPermissions } from '@/utils/accountPermissions';
import { getPrimaryAppRoleFromAccount } from './mapBackendRole';

/**
 * Where to send the user after login (or when visiting / as authenticated).
 * Leadership dashboards win over the admin-portal permission bundle: executives may
 * have MANAGE_USER + VIEW_REPORT but should still land on /executive. The admin
 * route is then permission-based for everyone else (and explicit admin/super_admin).
 *
 * @param {object} account - Full API account (login) or context user `{ role, permissions, ... }`.
 */
export function getPostLoginRoute(account) {
    if (!account) return ROUTES.HOME;
    if (account.passwordChanged === false) return ROUTES.CHANGE_PASSWORD;
    const appRole =
        account.role ?? getPrimaryAppRoleFromAccount(account);
    if (appRole === ROLES.EXECUTIVE) return ROUTES.EXECUTIVE;
    if (appRole === ROLES.TASK_FORCE_CHAIR) return ROUTES.TASK_FORCE_CHAIR;
    if (appRole === ROLES.PILLAR_CHAIR) return ROUTES.PILLAR_CHAIR;
    if (appRole === ROLES.PROJECT_MANAGER) return ROUTES.PROJECT_MANAGER;

    const mask = getEffectivePermissions(account);
    if (hasAllPermissions(mask, ...ADMIN_PORTAL_PERMISSIONS)) {
        return ROUTES.ADMIN;
    }
    if (appRole === ROLES.ADMIN || appRole === ROLES.SUPER_ADMIN) {
        return ROUTES.ADMIN;
    }
    return ROUTES.MEMBER;
}
